import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getUserPermissionsDetailFetchSuccess,
    getUserPermissionsDetailFetchFailure,
    updateUserPermissionsDetailFetchSuccess,
    updateUserPermissionsDetailFetchFailure,
} from './reducer';
import { UserPermissionsDetailResType } from 'src/types/userPermissionsDetail';
import { UserType } from 'src/types/user';
import translate from '@translate';
import { getUsersListFetch } from '../usersList/reducer';

const getUserPermissionsDetailFetchRequest = async (idUser: string) => {
    const res = await api('get', `api/secure/users/permission/${idUser}`);
    return res.data;
};

function* getUserPermissionsDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: UserPermissionsDetailResType = yield call((): any =>
            getUserPermissionsDetailFetchRequest(action.payload)
        );
        yield put(getUserPermissionsDetailFetchSuccess(response));
    } catch (error) {
        yield put(getUserPermissionsDetailFetchFailure({ error }));
    }
}

export function* getUserPermissionsDetailFetchWatch() {
    yield takeEvery('userPermissionsDetail/getUserPermissionsDetailFetch', getUserPermissionsDetailFetch);
}

const updateUserPermissionsDetailFetchRequest = async (params: { idUser: string; data: UserType }) => {
    const res = await api('put', `api/secure/users/permission/${params.idUser}`, params.data);
    return res.data;
};

function* updateUserPermissionsDetailFetch(action: { type: string; payload: { idUser: string; data: UserType } }) {
    try {
        const response: UserPermissionsDetailResType = yield call((): any =>
            updateUserPermissionsDetailFetchRequest(action.payload)
        );
        yield put(
            updateUserPermissionsDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('users.message.userPermissionsUpdate') },
            })
        );
        yield put(getUsersListFetch());
    } catch (error) {
        yield put(updateUserPermissionsDetailFetchFailure({ error }));
    }
}

export function* updateUserPermissionsDetailFetchWatch() {
    yield takeEvery('userPermissionsDetail/updateUserPermissionsDetailFetch', updateUserPermissionsDetailFetch);
}
